import { ChangeEvent, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { UserSquare } from '@phosphor-icons/react';

import {
  InternalPage,
  NoResultsMessage,
  Spacer,
  HomeLink,
} from 'theSource/components';
import {
  FORM_FIELDS,
  mapSubscriberModel,
} from './utils';
import { SettingsWrapperStyled } from './SettingsStyled';
import { selectNativeAuth, setIsEnabled } from 'theSource/services';
import {
  useSubscriberQuery,
} from 'theSource/queries';

export const Settings = () => {
  const { t } = useTranslation('pages.settings');
  const { isEnabled, isSupported } = useSelector(selectNativeAuth);
  const dispatch = useDispatch();

  const { subscriber: data } = useSubscriberQuery({ restrictAdmin: true });

  const categories = useMemo(
    () => data && mapSubscriberModel(data, FORM_FIELDS),
    [data]
  );

  const handleAuthToggle = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(setIsEnabled(event.target.checked));
  };

  useEffect(() => {
    const toggle = document.getElementById('native-auth-toggle-switch');
    if (!toggle) {
      return;
    }
    toggle.addEventListener('change', (event: any) => {
      handleAuthToggle(event);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnabled]);

  if (!categories) {
    return (
      <InternalPage testId="settings-page" title={t('title')}>
        <Spacer height={6} />
        {isSupported ? (
          <SettingsWrapperStyled data-testid="biometric-toggle-switch">
            <ps-toggle-switch
              checked={isEnabled ? true : null}
              input-id="native-auth-toggle-switch"
              data-testid="native-auth-toggle-switch"
              label={t('allowNativeAuthentication')}
              extra-class="text-dark"
            />
          </SettingsWrapperStyled>
        ) : (
          <NoResultsMessage
            testId="no-settings-message"
            IconComponent={UserSquare}
            message={t('noSettings')}
          />
        )}
      </InternalPage>
    );
  }

  return (
    <InternalPage
      testId="settings-page"
      title={t('title')}
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      {isSupported ? (
        <SettingsWrapperStyled data-testid="biometric-toggle-switch">
          <ps-toggle-switch
            checked={isEnabled ? true : null}
            data-testid="native-auth-toggle-switch"
            input-id="native-auth-toggle-switch"
            label={t('allowNativeAuthentication')}
            extra-class="text-dark"
          />
        </SettingsWrapperStyled>
      ) : (
        <NoResultsMessage
          testId="no-settings-message"
          IconComponent={UserSquare}
          message={t('noSettings')}
        />
      )}
    </InternalPage>
  );
};
